<script>
import {
  colorMap,
  colors,
} from "@/components/modules/new-dashboard/components/organizations-by-region/shared";
import { mapGetters } from "vuex";
import OrganizationsByRegionLabels from "@/components/modules/new-dashboard/components/organizations-by-region/organizations-by-region-labels.vue";
import DonutChart from "@/shared/charts/donut-chart/donut-chart.vue";
import TrackerOrganizationsByRegionLabels
  from "@/components/modules/tracker-dashboard/components/tracker-organizations-by-region/tracker-organizations-by-region-labels.vue";

export default {
  name: "TrackerOrganizationsByRegionWidget",
  components: { DonutChart, TrackerOrganizationsByRegionLabels },
  data: function () {
    return {
      formattedRegions: [],
      formattedCountries: [],
      colorMap,
      colors,
    };
  },
  watch: {
    getTrackerOrganizationsByCountry: {
      handler: function () {
        this.formatCountries();
        this.formatRegions();
      },
      deep: true,
    },
    getSelectedTrackerRegionInWidget: {
      handler: function () {
        this.formatCountries();
        this.formatRegions();
      },
      deep: true,
    },
    getTrackerOrganizationsByRegion: {
      handler: function () {
        this.formatCountries();
        this.formatRegions();
      },
      deep: true,
    },
  },
  mounted() {
    this.formatCountries();
    this.formatRegions();
  },
  computed: {
    ...mapGetters([
      "getTrackerOrganizationsByCountry",
      "getSelectedTrackerRegionInWidget",
      "getTrackerOrganizationsByRegion",
    ]),
  },
  methods: {
    formatRegions: function () {
      var totals = this.getTrackerOrganizationsByRegion.data.reduce(
        (previousValue, currentValue) => previousValue + +currentValue.count,
        0
      );

      var regions = {};

      this.getTrackerOrganizationsByRegion.data.forEach((region) => {
        if (typeof regions[region._id.region._id] === "undefined") {
          regions[region._id.region._id] = {
            id: region._id.region._id,
            name: this.$t(region._id.region.region),
            value: 0,
            percentage: "0",
            originalName: region._id.region.region,
          };
        }
        regions[region._id.region._id].value += +region.count;
        regions[region._id.region._id].percentage = (
          100 *
          (regions[region._id.region._id].value / totals)
        ).toFixed(0);
      });

      this.formattedRegions = Object.values(regions).sort((a, b) => a.name.localeCompare(b.name));
    },

    formatCountries: function () {
      if (!this.getSelectedTrackerRegionInWidget) {
        return [];
      }

      var countriesForRegion = this.getTrackerOrganizationsByRegion.data.filter(
        (region) => region._id.region._id === this.getSelectedTrackerRegionInWidget
      );
      var totals = countriesForRegion.reduce(
        (previousValue, currentValue) => previousValue + +currentValue.count,
        0
      );
      this.formattedCountries = countriesForRegion.map((country) => {
        return {
          id: country._id.country._id,
          value: country.count,
          name: this.$t(country._id.country.country),
          originalName: country._id.country.country,
          percentage: (100 * (country.count / totals)).toFixed(0),
        };
      }).sort((a, b) => a.name.localeCompare(b.name));
    },
    onSelectRegion: function (regionId) {
      this.$store.commit("setSelectedTrackerRegionInWidget", regionId);
    },
    onSelectCountry: function () {
      this.$store.commit("setSelectedTrackerRegionInWidget", null);
    },
  },
};
</script>

<template>
  <div>
    <div v-if="getTrackerOrganizationsByRegion.loading"
class="loading">
      <!--    <VueSpinner size="20" color="#213a7a"/>-->
    </div>
    <div
      v-if="!formattedRegions.length && !getTrackerOrganizationsByRegion.loading"
      class="loading"
    >
      {{ $t("label_dashboard_no_data_available") }}
    </div>

    <div
      v-if="formattedRegions.length && !getTrackerOrganizationsByRegion.loading"
      class="public-institutions-by-area"
      style="cursor: pointer"
    >
      <div
        v-if="!getSelectedTrackerRegionInWidget"
        class="public-institutions-by-region"
        :style="{ opacity: getSelectedTrackerRegionInWidget ? '0' : '1' }"
      >
        <donut-chart
          :color-map="colorMap"
          :colors="colors"
          :chart-data="formattedRegions"
          :on-select="onSelectRegion"
          :parent-size="false"
          :size="221"
        />
        <tracker-organizations-by-region-labels
          :colors="colors"
          :chart-data="formattedRegions"
          :on-select-region="onSelectRegion"
        />
      </div>
      <div
        v-if="formattedCountries.length && getSelectedTrackerRegionInWidget"
        class="public-institutions-by-region public-institutions-by-country"
        :style="{ opacity: getSelectedTrackerRegionInWidget ? '1' : '0' }"
      >
        <donut-chart
          :colors="colors"
          :chart-data="formattedCountries"
          :on-select="onSelectCountry"
          :color-map="colorMap"
          :parent-size="false"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.public-institutions-by-region {
  display: flex;
}

.public-institutions-by-area {
  position: relative;
  top: -10px;
}

.public-institutions-by-country {
  position: absolute;
  top: 0;
  left: 0;
}

.loading {
  height: 236px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style lang="scss">
.public-institutions-by-area-modal-container {
  height: 100%;

  .public-institutions-by-region,
  .public-institutions-by-country {
    height: 100%;
    width: 100%;
    align-items: center;
  }

  .donut-chart-svg {
    min-width: 100px;
    height: 100%;
  }

  .region-labels-container {
    height: 100%;
    align-items: center;

    .region-label-container {
      .region-label-name {
        font-size: 1.5vw !important;
        min-width: 12vw !important;
        max-width: 12vw !important;
        flex-basis: 15vw !important;
      }

      .region-label-value {
        font-size: 1.5vw !important;
        min-width: 5vw !important;
        max-width: 5vw !important;
        flex-basis: 15vw !important;
      }

      .region-label-color {
        width: 1.5vw !important;
        height: 1.5vw !important;
      }
    }
  }
}
</style>
